import * as React from "react";
import { Button } from "@vebox/etui-core";
import { JSONCensusEquipment } from "../../data/models/JSONCensusEquipment";
import { Loader } from "../../../../../components/Utils/loader/Loader";
import { JSONCensus } from "../../data/models/JSONCensus";

interface DeleteButtonProps {
	removeAction: (
		jsonCensusEquipment: JSONCensusEquipment,
	) => Promise<JSONCensus>;
	jsonCensusEquipment: JSONCensusEquipment;
	refreshEquipmentList: () => Promise<void>;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
	removeAction,
	jsonCensusEquipment,
	refreshEquipmentList,
}) => {
	const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
	const deleteAction = async () => {
		setIsDeleting(true);
		await removeAction(jsonCensusEquipment);
		setIsDeleting(false);
		await refreshEquipmentList();
	};
	return isDeleting ? (
		<Loader
			relativelyCentered={true}
			spinnerSize={1}
			key={"delete-loader-" + jsonCensusEquipment?.guid}
		/>
	) : (
		<Button
			key={"delete-" + jsonCensusEquipment?.guid}
			iconOnly={true}
			shape={"circle"}
			variant={"strong"}
			onClick={deleteAction}
			iconProps={{ symbol: "delete", weight: "400" }}
			styles={{ root: { height: "24px", width: "24px" } }}
		/>
	);
};
